import { deleteGroupAttributes } from '@dispatch/shared/services';
import { useMutation, useQueryClient } from 'react-query';

export const useDeleteGroupAttributes = (
  onSuccess: ({ success }: { success: boolean; message?: string }) => void,
  tenantId: string | undefined
) => {
  const { mutate, error, status } = useMutation(
    ['delete-group-attributes'],
    async (groupId: string) => {
      if (!tenantId) {
        throw new Error('TenantId is required for deleting a group attribute');
      }
      return deleteGroupAttributes(groupId, tenantId);
    },
    {
      onSuccess,
    }
  );
  return {
    deleteGroupAttributes: mutate,
    error,
    status,
  };
};
